
export const AllRolesList = {
    "Manage Admin Users": [
        "admin_user_list",
        "add_admin_user",
        "update_admin_user",
        "activate_or_deactivate_admin_user",
    ],
    "Manage Orders": [
        "order_list",
        "view_order"
    ],
    "Manage Stores": [
        "store_list",
        "add_store",
        "update_store",
        "activate_or_deactivate_store",
        'change_store_customization'
    ],
    "Manage Merchants": [
        "merchant_list",
        "onboard_merchant",
        "view_merchant",
        "update_merchant",
        "activate_or_deactivate_merchant",
        "send_email",
    ],
    "Manage Employee": [
        "employee_list",
        "add_employee",
        "update_employee",
        "activate_or_deactivate_employee"
    ],
    "Manage Support Requests": [
        "support_request_list",
        "view_support_request",
        "change_support_ticket_status"
    ],
    "Manage Settlements": [
        "settlement_list",
        "view_settlement",
        "change_settlement_status"
    ],
    "Manage Customers":[
        "customer_list",
        "send_SMS"
    ],
    "Other Privileges": [
        "view_dashboard"
    ]
};

export const MerchantRoleList = {
    "Manage Orders": [
        "order_list",
        "view_order"
    ],
    "Manage NFTs": [
        "nft_list",
        "view_detail"
    ],
    "Manage Products": [
        "product_list",
        "add_product",
        "update_product",
        // "activate_or_deactivate_product",
        "view_product",
        "stock_availability",
        "delete_product"
    ],
    "Manage Settlements": [
        "settlement_list",
        "view_settlement",
        "change_settlement_status"
    ],
    "Manage Employees": [
        "employee_list",
        "add_employee",
        "update_employee",
        "activate_or_deactivate_employee"
    ],
    "Manage Categories": [
        "category_list",
        "add_category",
        "update_category",
        "activate_or_deactivate_category"
    ],
    "Manage Carts": [
        "cart_list",
        "view_cart",
        "add_product_cart",
        "delete_cart_product",
        "delete_all_cart_products",
        "delete_cart",
        "create_cart_order"
    ],
    "Manage Stores": [
        "store_list",
        "add_store",
        "update_store",
        "activate_or_deactivate_store",
        'change_store_customization'
    ],
    "Manage Settings": [
        "setup_payment",
        "set_payout_settlement",
        "cart_timeout",
        "update_store_setting"
    ],
    "Manage Reserved Products": [
        "reserved_product_list",
        "view_reserved_product",
        "add_product_reserved",
        "ready_to_collect",
        "cancel_reservation",
        "delete_all_reserved_products",
        "delete_reserved_product",
        "create_reserved_order"
    ],
    "Manage Customers":[
        'customer_list',
        'send_email_or_SMS'
    ],
    'Manage Templates':[
        "SMS_template_list",
        'view_SMS_template',
        "create_SMS_template",
        "edit_SMS_template",
        "activate_or_deactivate_SMS_template",
        'delete_SMS_template',
        "email_template_list",
        'view_email_template',
        "create_email_template",
        "edit_email_template",
        "activate_or_deactivate_email_template",
        'delete_email_template',
    ],
    'Manage Unsold Products':[
        "unsold_scanned_products_list"
    ],
    "Other Privileges": [
        "view_dashboard"
    ]
};



export const Currencies = [
    {"code": "GBP", "name": "British Pound", "symbol": "£"},
    {"code": "USD", "name": "US Dollar", "symbol": "$"},
    {"code": "SGD", "name": "Singapore Dollar", "symbol": "$"},
    {"code": "EUR", "name": "Euro", "symbol": "€"},
    {"code": "HKD", "name": "Hong Kong Dollar", "symbol": "$"},
    {"code": "AED", "name": "United Arab Emirates Dirham", "symbol": "د.إ"},
    {"code": "AUD", "name": "Australian Dollar", "symbol": "$"},
    {"code": "BRL", "name": "Brazilian Real", "symbol": "R$"},
    {"code": "CAD", "name": "Canadian Dollar", "symbol": "$"},
    {"code": "CHF", "name": "Swiss Franc", "symbol": "Fr."},
    {"code": "CNY", "name": "Chinese Yuan", "symbol": "¥"},
    {"code": "IDR", "name": "Indonesian Rupiah", "symbol": "Rp"},
    {"code": "INR", "name": "Indian Rupee", "symbol": "₹"},
    {"code": "JPY", "name": "Japanese Yen", "symbol": "¥"},
    {"code": "NZD", "name": "New Zealand Dollar", "symbol": "$"},
    {"code": "PHP", "name": "Philippine Peso", "symbol": "₱"},
    {"code": "THB", "name": "Thai Baht", "symbol": "฿"},
    {"code": "VND", "name": "Vietnamese Dong", "symbol": "₫"},
    {"code": "ZAR", "name": "South African Rand", "symbol": "R"},
]

// Unsupported Currencies for BTSE Api
// const unsupportedCurrencies = [
//     {"code": "ARS", "name": "Argentine Peso", "symbol": "$"},
//     {"code": "DKK", "name": "Danish Krone", "symbol": "kr"},
//     {"code": "MOP", "name": "Macanese Pataca", "symbol": "MOP$"},
//     {"code": "MXV", "name": "Mexican Unidad de Inversion", "symbol": "MXV"},
//     {"code": "NOK", "name": "Norwegian Krone", "symbol": "kr"},
//     {"code": "SAR", "name": "Saudi Riyal", "symbol": "﷼"},
//     {"code": "SEK", "name": "Swedish Krona", "symbol": "kr"},
//     {"code": "TRY", "name": "Turkish Lira", "symbol": "₺"},
// ]